(function () {
    'use strict';

    /**
     * EDOCS-378: what the external page shows instead of a document when its link has expired. It says when, and
     * offers a new link to the same address when the server allows one (the link came from the workflow and the
     * address still belongs to an active user of the destination entity); otherwise it says whom to ask.
     *
     * Never shows the document nor the full address: whoever holds the hash is not necessarily the addressee.
     */
    var edExpiredLink = {
        templateUrl: 'app/external/expired-link/expired-link.html',
        bindings: {
            hash: '<',
        },
        controller: ExpiredLinkController,
    };

    angular.module('eDocumentsApp').component('edExpiredLink', edExpiredLink);

    ExpiredLinkController.$inject = ['$filter', 'Document'];

    /** A new link may be asked for again this long after the last one (the renewal window of DocumentShareService). */
    var RENEWAL_WINDOW_MS = 24 * 60 * 60 * 1000;

    function ExpiredLinkController($filter, Document) {
        var $ctrl = this;
        var formatDate = $filter('date');

        $ctrl.status = null;
        $ctrl.view = null;
        $ctrl.sent = null;
        $ctrl.loading = true;
        $ctrl.renewing = false;
        $ctrl.renewedTo = null;
        $ctrl.errorKey = null;
        $ctrl.renew = renew;

        $ctrl.$onInit = function () {
            loadStatus();
        };

        function loadStatus() {
            $ctrl.loading = true;
            return Document.linkStatus({ hash: $ctrl.hash }).$promise.then(
                function (status) {
                    showStatus(status);
                },
                function () {
                    // the page already knows the link expired; without its status it can only point to the sender
                    showStatus({ expired: true, renewable: false });
                }
            );
        }

        /**
         * Which of three things the page says: a new link already went out (#14: renewalSentAt, set for 24 h after a
         * renewal), a new link can be sent, or whom to ask. A reason not to renew wins over a recent renewal: when the
         * address no longer receives this document, pointing at its inbox would mislead.
         */
        function showStatus(status) {
            $ctrl.status = status;
            $ctrl.maskedRecipient = keepWhole(status.maskedRecipient);
            if (status.renewalSentAt && !status.notRenewableReason) {
                $ctrl.view = 'sent';
                $ctrl.sent = sentWhen(status.renewalSentAt, status.renewalAvailableAt);
            } else if (status.renewable) {
                $ctrl.view = 'offer';
            } else {
                $ctrl.view = 'ask';
            }
            $ctrl.loading = false;
        }

        /** dd/MM/yyyy and HH:mm in the reader's time zone; without renewalAvailableAt, 24 h after the last renewal. */
        function sentWhen(sentAt, availableAt) {
            var next = availableAt || new Date(new Date(sentAt).getTime() + RENEWAL_WINDOW_MS);
            return {
                date: formatDate(sentAt, 'dd/MM/yyyy'),
                time: formatDate(sentAt, 'HH:mm'),
                next: formatDate(next, 'dd/MM/yyyy HH:mm'),
            };
        }

        /** An address reads as one word: its hyphens become non-breaking, so a narrow screen does not split it. */
        function keepWhole(address) {
            return address ? address.replace(/-/g, '‑') : address;
        }

        function renew() {
            if ($ctrl.renewing) {
                return;
            }
            $ctrl.renewing = true;
            $ctrl.errorKey = null;
            Document.renewLink({}, { hash: $ctrl.hash }).$promise.then(
                function (result) {
                    $ctrl.renewing = false;
                    $ctrl.renewedTo = keepWhole(result.maskedRecipient || $ctrl.status.maskedRecipient);
                },
                function (error) {
                    $ctrl.renewing = false;
                    var errorKey = error && error.data && error.data.message ? error.data.message : 'error.linkResendNotAvailable';
                    if (error && error.status === 429) {
                        // #14 RESEND_ALREADY_SENT: a new link went out meanwhile (another tab, another reader): say when,
                        // not only "no"; the red message stays for a server that does not report renewalSentAt
                        loadStatus().then(function () {
                            if ($ctrl.view !== 'sent') {
                                $ctrl.errorKey = errorKey;
                            }
                        });
                        return;
                    }
                    $ctrl.errorKey = errorKey;
                }
            );
        }
    }
})();
